export const getUser = state => state.user;
export const getToken = ({ token }) => token;

export const hasToken = ({ token }) => !!token;
